import { Icon, InputGroup } from "@blueprintjs/core"
import CustomTooltip from "components/Atoms/CustomTooltip"
import SerialColumn from "components/Organisms/table/SerialColumn"
import React from "react"
import ReactTable from "react-table"
import { useGenerateTripStore } from "store/generateTripStore"

function renderBackground(original: any, key: string) {
  const error = original?.errors?.[key]
  return {
    style: {
      background: original?.id ? (error ? "#ffc4c4" : "#caf1e1") : null,
    },
  }
}
const COLUMNS = [
  SerialColumn,
  {
    Header: "Plot Commodity",
    accessor: "plotCommodity",
    width: 240,
    Cell({ value }) {
      return value?.name ?? ""
    },
  },
  {
    Header: "Vehicle",
    accessor: "vehicle",

    Cell({ value, original }) {
      const error = original?.errors?.vehicle
      return (
        <>
          {error ? (
            <CustomTooltip content={error}>
              {value?.registrationNumber ?? "na"}
            </CustomTooltip>
          ) : (
            value?.registrationNumber ?? "na"
          )}
        </>
      )
    },
    getProps: (_, data) => renderBackground(data?.original, "vehicle"),
  },
  {
    Header: "Transport Service Provider",
    accessor: "transportServiceProvider",
    Cell({ value, original }) {
      const error = original?.errors?.aggregator

      return (
        <>
          {error ? (
            <CustomTooltip content={error}>
              {value?.fullName ?? "na"}
            </CustomTooltip>
          ) : (
            value?.fullName ?? "na"
          )}
        </>
      )
    },
    getProps: (_, data) => renderBackground(data?.original, "aggregator"),
  },
  {
    Header: "Aggregator",
    accessor: "aggregator",
    Cell({ value, original }) {
      const error = original?.errors?.aggregator

      return (
        <>
          {error ? (
            <CustomTooltip content={error}>
              {value?.fullName ?? "na"}
            </CustomTooltip>
          ) : (
            value?.fullName ?? "na"
          )}
        </>
      )
    },
    getProps: (_, data) => renderBackground(data?.original, "aggregator"),
  },
  {
    Header: "UOMs",
    accessor: "farmWeight",
    Cell({ value, original }) {
      const error = original?.errors?.farmWeight
      return (
        <>
          {error ? (
            <CustomTooltip content={error}>
              {`${value} ${original?.farmQuantityUnit?.codename ?? "na"}` ?? ""}
            </CustomTooltip>
          ) : (
            `${value} ${original?.farmQuantityUnit?.codename ?? "na"}` ?? ""
          )}
        </>
      )
    },
    getProps: (_, data) => renderBackground(data?.original, "farmWeight"),
  },
  {
    Header: "SKUs",
    accessor: "requiredQuantity",
    Cell({ value, original, index }) {
      const error = original?.errors?.requiredQuantity

      return (
        <>
          {error ? (
            <CustomTooltip content={error}>
              {`${value} ${original?.skuType?.name}` ?? ""}
            </CustomTooltip>
          ) : (
            `${value} ${original?.skuType?.name}` ?? ""
          )}
        </>
      )
    },
    getProps: (_, data) => renderBackground(data?.original, "requiredQuantity"),
  },

  {
    Header: "Grade Prices",
    accessor: "gradePrices",
    Cell({ original }) {
      const error = original?.errors?.gradePrices

      return (
        <>
          {error ? (
            <CustomTooltip content={error}>
              <Icon intent="danger" icon="cross" />
            </CustomTooltip>
          ) : (
            <Icon icon="endorsed" intent="success" />
          )}
        </>
      )
    },
    getProps: (_, data) => renderBackground(data?.original, "gradePrices"),
  },
  {
    Header: "Source Depot",
    accessor: "sourceDepot",
    Cell({ value, original }) {
      const error = original?.errors?.sourceDepot

      return (
        <>
          {error ? (
            <CustomTooltip content={error}>
              {`${value?.name}` ?? ""}
            </CustomTooltip>
          ) : (
            `${value?.name}` ?? ""
          )}
        </>
      )
    },
    getProps: (_, data) => renderBackground(data?.original, "sourceDepot"),
  },
  {
    Header: "Destination Depot",
    accessor: "destinationDepot",
    Cell({ value, original }) {
      const error = original?.errors?.destinationDepot

      return (
        <>
          {error ? (
            <CustomTooltip content={error}>
              {`${value?.name}` ?? ""}
            </CustomTooltip>
          ) : (
            `${value?.name}` ?? ""
          )}
        </>
      )
    },
    getProps: (_, data) => renderBackground(data?.original, "destinationDepot"),
  },
  {
    Header: "Picked Quantity",
    accessor: "createdAt",
    Cell({ index, original }) {
      const value = useGenerateTripStore(
        store => store.schedules?.[index]?.procuredQuantity
      )
      const changeProcuredQuantity = useGenerateTripStore(
        store => store.changeProcuredQuantity
      )
      return (
        <InputGroup
          max={original.requiredQuantity}
          min={0}
          type="number"
          value={value}
          onChange={value => changeProcuredQuantity(index, value.target.value)}
        />
      )
    },
    getProps: (_, data) => renderBackground(data?.original, "procuredQuantity"),
  },
]

export default function TripsAlertTable() {
  const schedulesToValidate = useGenerateTripStore(store => store.schedules)

  return (
    <ReactTable
      className="-highlight"
      defaultSorted={[
        {
          id: "farmWeight",
          desc: false,
        },
      ]}
      columns={COLUMNS as any}
      style={{
        height: 300,
        overflow: "visible",
      }}
      data={schedulesToValidate}
      pageSize={
        schedulesToValidate?.length > 7 ? schedulesToValidate?.length : 7
      }
      showPaginationBottom={false}
    />
  )
}
